import * as ngCore from '@angular/core'

import * as state from '../../../../../state'

import * as modal from './modal'
import * as moodPopUp from './mood-pop-up'

@ngCore.Component({
  imports: [moodPopUp.Component, modal.Component],
  selector: 'atn-check-in-wizard',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.summit.checkIn.Feature} */
  public readonly checkInFeature = ngCore.inject(state.summit.checkIn.Feature)
}
